<template>
  <div>
    <Card>
      <Form ref:form-inline
      inline>
        <Form-item>
          <Upload :on-success="handleSuccess"
                  :on-error="handleError"
                  :action="uploadUrl"
                  :headers="headers">
            <Button icon="ios-cloud-upload-outline">{{$t('pages_customers_index_303')}}</Button>
          </Upload>
        </Form-item>
        <Form-item>
          <a href="https://fresh-picture.chengbao68.com/%E4%BC%9A%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
            download>
            <Button>{{$t('pages_customers_index_304')}}</Button>
          </a>
        </Form-item>
      </Form>
      <div class="filter-container">
        <el-input
          clearable
          @keyup.enter.native="searchBtnClick"
          style="width: 200px;"
          class="filter-item"
          :placeholder="$t('pages_customers_index_305')"
          v-model="searchData.mobile"
        />
        <el-input
          clearable
          @keyup.enter.native="searchBtnClick"
          style="width: 200px;"
          class="filter-item"
          :placeholder="$t('pages_customers_index_306')"
          v-model="searchData.username"
        />
        <el-input
          clearable
          @keyup.enter.native="searchBtnClick"
          style="width: 200px;"
          class="filter-item"
          :placeholder="$t('pages_customers_index_307')"
          v-model="searchData.card_code"
        />
        <el-select clearable
                   style="width: 200px"
                   class="filter-item"
                   v-model="searchData.has_order"
                   :placeholder="$t('pages_customers_index_308')">
          <el-option :label="$t('pages_customers_index_309')"
                     value="" />
          <el-option :label="$t('pages_customers_index_310')"
                     value="true" />
        </el-select>
        <el-button
          size="medium"
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="searchBtnClick()"
          >{{$t('pages_bills_index_196')}}</el-button>
        <el-button type="primary" class="filter-item" size="medium" @click="exportData()" icon="el-icon-search">{{$t('pages_customers_index_311')}}</el-button>
      </div>
      <el-alert
        v-if="aggregate_test"
        :title="aggregate_test"
        type="success"
        :closable="false"
      ></el-alert>
      <Table
        style="margin-top: 20px;"
        ref="table"
        border
        :loading="loading"
        :columns="columns"
        :data="customers"
        @on-row-click="onRowClick"
      ></Table>
      <Row>
        <Page
          style="margin-top: 20px;"
          show-total
          :total="meta.total"
          :current="meta.current"
          :page-size="meta.pageSize"
          @on-change="changePage"
        ></Page>
      </Row>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" :title="$t('pages_customers_index_312')">
      <Form ref="customer" :model="customer" :label-width="80">
        <Form-item :label="$t('pages_customers_index_313')" prop="username">
          <Input type="text" v-model="customer.username" />
        </Form-item>
        <Form-item :label="$t('pages_customers_index_307')" prop="card_code">
          <Input type="text" v-model="customer.card_code" />
        </Form-item>
        <Form-item :label="$t('pages_customers_index_314')" prop="mobile">
          <Input type="text" v-model="customer.mobile" />
        </Form-item>
        <Form-item :label="$t('pages_customers_index_315')" prop="fresh_customer_level_id">
          <Select v-model="customer.fresh_customer_level_id">
            <Option v-for="item in customer_levels" :value="item.id" :key="`search-col-${item.id}`">{{ item.name }}</Option>
          </Select>
        </Form-item>
      </Form>
    </Modal>
    <Modal
      v-model="modalShowResetPassword"
      @on-ok="handleSubmit"
      :title="$t('pages_account_reset_148')"
    >
      <Form ref="customer" :model="customer" :label-width="80">
        <Form-item :label="$t('pages_customers_index_316')" prop="password">
          <Input type="text" v-model="customer.password" />
        </Form-item>
        <Form-item :label="$t('pages_customers_index_317')" prop="password_confirm">
          <Input type="text" v-model="customer.password_confirm" />
        </Form-item>
      </Form>
    </Modal>
    <Modal
      v-model="modalShowBillRecharge"
      @on-ok="billRecharge"
      :title="$t('pages_customers_index_318')"
    >
      <Form ref="customer" :model="rechargeModel" :label-width="80">
        <Form-item :label="$t('pages_bills_index_202')" prop="amount">
          <Input type="text" v-model="rechargeModel.amount" />
        </Form-item>
        <Form-item :label="$t('pages_bills_index_203')" prop="give">
          <Input type="text" v-model="rechargeModel.give" />
        </Form-item>
         <Form-item :label="$t('pages_bills_index_204')" prop="second_card">
          <Input type="text" v-model="rechargeModel.second_card" />
        </Form-item>
        <Form-item :label="$t('pages_customers_index_319')" prop="payment_method">
          <Select
            v-model="rechargeModel.payment_method"
            :placeholder="$t('pages_customers_index_320')"
          >
          <template v-for="item in paymentMethods">
            <Option
              v-if="['lcsw_wx_pay', 'lcsw_ali_pay'].indexOf(item.value) === -1"
              :key="item.value"
              :value="item.value"
              >{{ item.name }}</Option
            >
          </template>
          </Select>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="modalShowFunction" :title="$t('pages_customers_index_321')">
      <ButtonGroup size="large">
        <Button type="warning" @click="this.update2">{{$t('pages_customers_index_322')}}</Button>
        <Button type="default" @click="this.orders">{{$t('pages_cleaner_index_259')}}</Button>
        <Button type="info" @click="this.showBillRecharge">{{$t('pages_customers_index_318')}}</Button>
        <Button vertical type="primary" @click="this.bills">{{$t('pages_customers_index_323')}}</Button>
        <Button
          type="warning"
          v-show="this.customer.status === 'stopped'"
          @click="this.start2"
          >{{$t('pages_customers_index_324')}}</Button
        >
        <Button
          type="warning"
          v-if="this.customer.score === 0 && this.customer.balance === 0"
          @click="this.destroy2"
          >{{$t('pages_customers_index_325')}}</Button
        >
        <Button
          type="error"
          v-if="
            (this.customer.score !== 0 || this.customer.balance !== 0) &&
              this.customer.status === 'valid'
          "
          @click="this.stop2"
          >{{$t('pages_customers_index_326')}}</Button
        >
        <Button type="info" @click="this.reset_password">{{$t('pages_account_reset_148')}}</Button>
        <Button type="primary" @click="this.bind_promote_staff" v-if="this.customer.mobile">{{$t('pages_customers_index_327')}}</Button>
      </ButtonGroup>
    </Modal>
    <Modal
      v-model="modalShowBindPromote"
      :loading="bindingPromote"
      @on-ok="handleBindPromote"
      :title="$t('pages_customers_index_327')"
    >
      <Form ref="promote" :model="promote" :rules="promoteRules" :label-width="120">
        <Form-item :label="$t('pages_customers_index_328')"
                    prop="promote_company_id">
          <el-select clearable
                  style="width: 300px"
                  v-model="promote.promote_company_id"
                  @change="changeCompany"
                  :placeholder="$t('pages_customers_index_328')">
            <el-option :label="company.name" :value="company.id" v-for="company in promote_companies" :key="company.id" />
          </el-select>
        </Form-item>
        <Form-item :label="$t('pages_customers_index_329')"
                    prop="promote_company_staff_id">
          <el-select clearable
                    style="width: 300px"
                    v-model="promote.promote_company_staff_id"
                    :placeholder="$t('pages_customers_index_330')">
            <el-option :label="staff.username" :value="staff.id" v-for="staff in promote_company_staffs" :key="staff.id" />
          </el-select>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { tableAvatar } from '@/libs/table-render'
import { setReadIc } from '@/libs/android_jsbridge'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
import { paymentMethods } from '@/libs/value-list.js'

export default {
  data () {
    const vm = this
    return {
      paymentMethods,
      searchData: {
        id: undefined
      },
      modalShowFunction: false,
      modalShow: false,
      uploadUrl: `${process.env.VUE_APP_API_HOST}/customers/import`,
      headers: {
        Authorization: Cookies.get(TOKEN_KEY),
        ShopId: localStorage.getItem('SHOPID')
      },
      modalShowResetPassword: false,
      modalShowBillRecharge: false,
      modalShowBindPromote: false,
      columns: [
        {
          title: 'ID',
          width: 100,
          key: 'id',
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_331'),
          key: 'come_from',
          width: 150,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_332'),
          key: 'fingerprint_code',
          width: 150,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_314'),
          key: 'mobile',
          width: 160,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_333'),
          key: 'username',
          width: 150,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_334'),
          key: 'nickname',
          width: 150,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_307'),
          key: 'card_code',
          width: 150,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_315'),
          key: 'fresh_customer_level_name',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_335'),
          key: 'consume_total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_336'),
          key: 'storage_total',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_337'),
          key: 'balance',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_bills_index_204'),
          key: 'second_card',
          width: 100,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_338'),
          key: 'score',
          width: 100,
          align: 'center'
        }
      ].concat([]).concat([
        {
          title: i18n.t('pages_balance_transaction_index_176'),
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.status === 'valid' ? '正常' : i18n.t('pages_customers_index_340'))
          }
        },
        {
          title: i18n.t('pages_customers_index_341'),
          key: 'avatar',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return tableAvatar(h, params.row.avatar)
          }
        },
        {
          title: i18n.t('pages_customers_index_329'),
          key: 'promote_company_staff_username',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.is_internal_staff ? params.row.promote_company_staff_username : '')
          }
        },
        {
          title: i18n.t('pages_customers_index_342'),
          key: 'promote_company_staff_username',
          width: 110,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.is_internal_staff ? '' : params.row.promote_company_staff_username)
          }
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at',
          width: 180,
          align: 'center'
        },
        // {
        //   title: '性别',
        //   width: 100,
        //   key: 'gender',
        //   align: 'center'
        // },
        {
          title: i18n.t('libs_table_render_96'),
          key: 'birthday',
          width: 160,
          align: 'center'
        }
      ]),
      rechargeModel: {
        payment_method: 'cash_pay',
        amount: 0,
        give: 0,
        second_card: 0,
        customer_id: '',
        auth_no: '',
      },
      promote: {},
      bindingPromote: true,
      promoteRules: {
        promote_company_id: [{ required: true, message: i18n.t('pages_customers_index_343') }],
        promote_company_staff_id: [{ required: true, message: i18n.t('pages_customers_index_344') }]
      },
    }
  },
  created () {
    this.index()
  },
  mounted () {
    setReadIc((code) => {
      this.resetQuery()
      this.searchData.username = code
      this.changeQuery({ card_code: code })
      this.index()
      this.customerLevelIndex({ per: 65535 })
    })
  },
  computed: {
    ...mapGetters('customer', ['customers', 'customers_all', 'customer', 'aggregate_test', 'meta', 'loading']),
    ...mapState('customer_level', ['customer_levels']),
    ...mapGetters('editor', ['editor']),
    ...mapGetters('promote_company', ['promote_companies']),
    ...mapGetters('promote_company_staff', ['promote_company_staffs']),
  },
  methods: {
    ...mapActions('customer_level', { customerLevelIndex: 'index' }),
    ...mapActions('customer', [
      'clear',
      'index',
      'index_all',
      'show',
      'create',
      'update',
      'destroy',
      'start',
      'stop'
    ]),
    ...mapActions('bill', { billPay: 'billPay', billCreate: 'create' }),
    ...mapActions('promote_company', { companyIndex: 'index' }),
    ...mapActions('promote_company_staff', { staffIndex: 'index' }),
    ...mapMutations('customer', ['changeQuery', 'resetQuery']),
    ...mapMutations('promote_company_staff', { changeStaffQuery: 'changeQuery' }),
    handleSuccess (res, file) {
      this.$Message.success(i18n.t('pages_customers_index_345'))
    },
    handleError (error, res) {
      console.log(error)
      this.$Message.error(res.message)
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    handleSubmit () {
      this.update(this.customer)
      this.modalShow = false
      this.modalShowResetPassword = false
      this.modalShowFunction = false
    },
    async billRecharge () {
      const data = await this.billCreate({ ...this.rechargeModel, _mute_: true })
      data.id && await this.billPay({
        id: data.id,
        payment_method: this.rechargeModel.payment_method,
        auth_no: '',
      })
    },
    searchBtnClick () {
      this.resetQuery()
      this.changeQuery(this.searchData)
      this.index()
    },
    orders () {
      this.$router.push(`/customers/${this.customer.id}/orders`)
    },
    bills () {
      this.$router.push(`/customers/${this.customer.id}/bills`)
    },
    reset_password () {
      this.show(this.customer.id)
      this.modalShowResetPassword = true
    },
    async bind_promote_staff () {
      await this.companyIndex()
      this.modalShowBindPromote = true
    },
    changeCompany (value) {
      // console.info('changeCompany', value)
      if (value) {
        this.changeStaffQuery({
          promote_company_id: value
        })
        this.staffIndex()
      } else {
        this.promote.promote_company_staff_id = ''
      }
    },
    handleBindPromote () {
      this.$refs.promote.validate(async valid => {
        if (!valid) {
          this.bindingPromote = false
          this.$nextTick(() => {
            this.bindingPromote = true
          })
          return
        }

        await this.update(Object.assign({
          id: this.customer.id,
          is_internal_staff: true
        }, this.promote))
        this.modalShowBindPromote = false
      })
    },
    showBillRecharge () {
      this.rechargeModel.customer_id = this.customer.id
      this.modalShowBillRecharge = true
    },
    onRowClick (params) {
      this.modalShowFunction = true
      this.show(params.id)
    },
    start2 () {
      this.start(this.customer.id)
      this.modalShowFunction = false
    },
    stop2 () {
      this.$Modal.confirm({
        title: i18n.t('pages_customers_index_346'),
        content: i18n.t('pages_customers_index_347'),
        onOk: () => {
          this.stop(this.customer.id)
          this.modalShowFunction = false
        }
      })
    },
    destroy2 () {
      this.$Modal.confirm({
        title: i18n.t('pages_customers_index_348'),
        content: i18n.t('pages_customers_index_349'),
        onOk: () => {
          this.destroy(this.customer.id)
          this.modalShow = false
          this.modalShowFunction = false
        }
      })
    },
    update2 () {
      this.modalShow = true
    },
    async exportData () {
      await this.index_all(Object.assign({ per: 100 }, this.searchData))
      this.$refs.table.exportCsv({
        // quoted: true,
        // separator: ',=',
        // original: false,
        columns: this.columns,
        data: this.customers_all,
        filename: i18n.t('pages_customers_index_350')
      })
    }
  }
}
</script>
